export const chartColors: string[] = [
  '#f1416c',
  '#3e97ff',
  '#50cd89',
  '#ffc107',
  '#6f42c1',
  '#ff6b6b',
  '#00bcd4',
  '#ff9800',
  '#795548',
  '#9e9e9e',
  '#8bc34a',
  '#673ab7',
  '#009688',
  '#cddc39',
  '#e91e63',
  '#607d8b',
  '#ff5722',
  '#4caf50',
  '#2196f3',
  '#9c27b0',
  '#b71c1c',
  '#1a237e',
  '#004d40',
  '#33691e',
  '#f57f17',
  '#e65100',
  '#3e2723',
  '#212121',
  '#263238',
  '#880e4f',
  '#bf360c',
  '#0d47a1',
  '#1b5e20',
  '#827717',
  '#fbc02d',
  '#ff1744',
  '#651fff',
  '#00e5ff',
  '#76ff03',
  '#ff4081',
  '#c2185b',
  '#7b1fa2',
  '#512da8',
  '#303f9f',
  '#1976d2',
  '#0288d1',
  '#0097a7',
  '#00796b',
  '#388e3c',
  '#689f38',
  '#afb42b',
  '#fbc02d',
  '#ffa000',
  '#f57c00',
  '#e64a19',
  '#5d4037',
  '#616161',
  '#455a64',
  '#d32f2f',
  '#c2185b',
  '#7b1fa2',
  '#512da8',
  '#303f9f',
  '#1976d2',
  '#0288d1',
  '#0097a7',
  '#00796b',
  '#388e3c',
  '#689f38',
  '#afb42b',
  '#fbc02d',
  '#ffa000',
  '#f57c00',
  '#e64a19',
  '#5d4037',
  '#616161',
  '#455a64',
  '#8d6e63',
  '#90a4ae',
  '#b0bec5',
  '#ce93d8',
  '#ba68c8',
  '#9575cd',
  '#7986cb',
  '#64b5f6',
  '#4fc3f7',
  '#4dd0e1',
  '#4db6ac',
  '#81c784',
  '#aed581',
  '#dce775',
  '#fff176',
  '#ffd54f',
  '#ffb74d',
  '#ff8a65',
  '#a1887f',
  '#e0e0e0',
  '#bdbdbd',
  '#9fa8da',
  '#80cbc4',
]

const generateColor = (index: number) => {
  const hue = (index * 37) % 360 // distribui bem no círculo de cores
  const saturation = 70
  const lightness = 50
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`
}

export const getChartColor = (index: number) => {
  if (index < chartColors.length) {
    return chartColors[index]
  }
  return generateColor(index)
}
